import React from "react"
import { Grid } from "@mui/material"
import { useOfficeMappingFilter } from "Pages/Admin/OfficeMapping/@hooks"
import {AppAsyncOfficesAutocomplete, AppButtonIcon, AppOfficesAutocomplete, AppRetailerBlock} from "@components"
import { AutocompleteAjaxSeeker, AutocompleteSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import { getExcel } from "@ui-seeker/utils"


export default function OfficeMappingFilters() {

	const {
		submitFilters,
		office,
		company,
		sites,
		markets,
		officeTypes,
		marketsFilter,
		officeTypesFilter,
		handleChangeCompany,
		handleChangeOffice,
		handleChangeSite,
		handleChangeMarkets,
		handleChangeOfficeTypes,
		sitesOptions
	} = useOfficeMappingFilter()

	return <Grid container spacing={2} alignItems="center" sx={{ flexWrap: 'nowrap' }}>
		<Grid item xs={2} sx={{ minWidth: 200 }}>
			<AutocompleteAjaxSeeker
				filterSelectedOptions={false}
				disableClearable
				label="Company"
				placeholder="All Companies"
				value={company}
				onChange={e => handleChangeCompany(e.target.value)}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/companies`}
			/>
		</Grid>
		{!!company && <Grid item xs={2} sx={{ minWidth: 200 }}>
			<AutocompleteAjaxSeeker
				filterSelectedOptions={false}
				disableClearable={false}
				multiple
				label="Countries"
				placeholder="All Countries"
				value={markets}
				onChange={e => handleChangeMarkets(e.target.value)}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/company-office-countries`}
				filters={{ company }}
			/>
		</Grid>}
		{!!company && <Grid item xs={2} sx={{ minWidth: 200 }}>
			<AutocompleteAjaxSeeker
				filterSelectedOptions={false}
				disableClearable={false}
				multiple
				label="Office Types"
				placeholder="All Types"
				value={officeTypes}
				onChange={e => handleChangeOfficeTypes(e.target.value)}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/company-office-types`}
				filters={{ company }}
			/>
		</Grid>}
		<Grid item xs={2} sx={{ minWidth: 200 }}>
			{!!company && <AppOfficesAutocomplete
				key={`${marketsFilter}-${officeTypesFilter}`}
				disableClearable={false}
				value={office}
				onChange={e => {
					handleChangeOffice(e.target.value)
					submitFilters()
				}}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/company-offices`}
				filters={{ company, ...(marketsFilter && { markets: marketsFilter }), ...(officeTypesFilter && { officeTypes: officeTypesFilter }) }}
			/>}
		</Grid>
		<Grid item xs={3} sx={{ minWidth: 200 }}>
			{(!!company && !!office) && <AutocompleteSeeker
				filterSelectedOptions={false}
				disableClearable={false}
				options={sitesOptions}
				label="Sites"
				placeholder="All Sites"
				getOptionLabel={({ value }) => value}
				formatOptionLabel={({ value, label }) => <AppRetailerBlock retailer={value} country={label}/>}
				value={sites}
				multiple
				onChange={e => handleChangeSite(e.target.value)}
			/>}
		</Grid>
		{!!company && <Grid item sx={{ flexShrink: 0 }}>
			<AppButtonIcon
				onClick={() => getExcel(`${BACKEND_APIS.OFFICE_MAPPING}/help`, { company })}
				sx={{ color: 'colors.green', fontSize: 24 }}
				icon="file-excel"
				tooltip="Download Company Help Mapping"
			/>
		</Grid>}
	</Grid>
}